import { useRef } from 'react';

import { TDealDetails } from '@crm/entities/deal';
import { useIsClamped } from '@crm/shared/lib';

export const DealTitle = ({ name }: { name: TDealDetails['dealData']['name'] }) => {
    const titleRef = useRef<HTMLHeadingElement>(null);
    const isTitleClamped = useIsClamped(titleRef);

    return (
        <h1
            ref={titleRef}
            className="min-w-0 truncate text-2xl leading-6 font-semibold text-smtr-main-black-100"
            title={isTitleClamped ? name : undefined}
        >
            {name}
        </h1>
    );
};
